<script setup>
import { ref, computed, onMounted, getCurrentInstance } from "vue";
import { useRoute, useRouter } from "vue-router";
import { usePageLoadingStore } from "../../../../../stores/pageLoading";
import adminJobfairStateService from "../../../services/jobfair/adminJobfairStateService";
import JobFairJobNoticeDetailModal from "../../../../user/components/modal/jobFair/JobFairJobNoticeDetailModal.vue";

const { $pageListBoardNo, $toast, $number, $gbNameKR, $yyyymmdd, $yyyymmddHHmmss, alert, confirm } = getCurrentInstance().appContext.config.globalProperties;

const route = useRoute();
const router = useRouter();
const loadingStore = usePageLoadingStore();

const props = defineProps({
  userId: {
    type: [String, Number],
    required: true,
  }
});

const currentPage = ref(1);
const pageSize = ref(10);
const totalPages = ref(1);
const totalCount = ref(0);
const list = ref([]);

const jobNoticeModal = ref(null); // 채용공고

const pageSizeGroup = ref([
  { label:"10개씩 보기", value: 10 },
  { label:"30개씩 보기", value: 30 },
  { label:"50개씩 보기", value: 50 },
  { label:"100개씩 보기", value: 100 },
])

const onSelectPage = (pageNo) => {
  currentPage.value = pageNo;
  retrieveList();
}

// 페이지당 개수 변경
const onSelectPageSize = (option) => {
  pageSize.value = option.value;
  currentPage.value = 1;
  retrieveList();
}

const retrieveList = () => {
  let paramObj = {
    userId: props.userId,
    pageNumber: currentPage.value,
    size: pageSize.value,
  }
  loadingStore.loading = true;
  adminJobfairStateService.retrieveInterestJobNoticeListPagingByUserId(paramObj)
    .then( async (res) => {
      loadingStore.loading = false;
      if (res.data.code.toLowerCase() === "success") {
        const result = res.data.result;
        totalPages.value = result.totalPages;
        totalCount.value = result.totalElements;
        list.value = $pageListBoardNo(result.content, totalCount.value, pageSize.value, currentPage.value);
      }
    })
    .catch((res) => {
      loadingStore.loading = false;
      $toast("error", res);
    });
};


// 채용공고 보기
const onClickJobNotice = async (jobNoticeSeq, corpId) => {
  await jobNoticeModal.value.show({
    jobNoticeSeq,
    corpId,
  });
}

const openDetailInNewTab = (linkName, id, query = {}) => {
  const url = router.resolve({
    name: linkName,
    params: { id },
    query,
  }).href;

  window.open(url, '_blank');
}

onMounted(()=>{
  retrieveList();
});
</script>

<template>
  <div>
    <!-- s: 버튼영역 -->
    <div class="list-top">
      <p>전체 <span>{{ $number(totalCount)}}</span>개</p>
      <KSASelect :options="pageSizeGroup" class="select" @selectOption="onSelectPageSize"/>
    </div>
    <!-- e: 버튼영역 -->
    <div class="table-form">
      <table class="horizontal" v-if="list !== null">
        <tr>
          <th>NO</th>
          <th>채용상태</th>
          <th>기업명</th>
          <th>채용공고 제목</th>
          <th>마스터</th>
          <th>관심 카테고리</th>
          <th>면접 방식</th>
          <th>채용기간</th>
          <th>관심 등록일</th>
          <th>입사지원 상태</th>
        </tr>
        <tr v-for="interestedJob in list">
          <td>{{ interestedJob.boardNo }}</td>
          <td>{{ $gbNameKR("JOB_NOTICE_STATE_GB", interestedJob.jobNoticeStateGb) }}</td>
          <td class="clickable blue text-overflow long-overflow">
            <span @click="openDetailInNewTab('CorporationDetail', interestedJob.corpId, { tab: 3, tab2: 'job-postings' })">{{ interestedJob.corpName }}</span>
          </td>
          <td class="clickable blue text-overflow long-overflow" @click="onClickJobNotice(interestedJob.jobNoticeSeq, interestedJob.corpId)">{{ interestedJob.jobName }}</td>
          <td class="clickable blue">
            <span @click="openDetailInNewTab('MemberDetail', interestedJob.userId)">{{ interestedJob.userName }}</span>
          </td>
          <td>{{ interestedJob.interests }}</td>
          <td>{{ $gbNameKR("INTV_GB", interestedJob.intvGb) }}</td>
          <td>{{ $yyyymmdd(interestedJob.recruitStartYmd) }} ~ {{ $yyyymmdd(interestedJob.recruitEndYmd) }}</td>
          <td>{{ $yyyymmddHHmmss(interestedJob.modifyDate) }}</td>
          <td>
            <span v-if="interestedJob.jobNoticeStateGb === '01'" class="gray">지원대기</span>
            <span v-else-if="interestedJob.applyStateGb === '01' || interestedJob.applyStateGb === '02' || interestedJob.applyStateGb === '03' || interestedJob.applyStateGb === '04' || interestedJob.applyStateGb === '05' || interestedJob.applyStateGb === '06'" class="gray">지원완료</span>
            <span v-else>-</span>
          </td>
        </tr>
      </table>
      <div class="result-none" v-if="list.length === 0">
        등록된 관심 공고가 없습니다.
      </div>
    </div>
    <Paginate
      v-if="list.length > 0"
      v-model="currentPage"
      :page-count="totalPages"
      :click-handler="onSelectPage"
    />
  </div>
  <JobFairJobNoticeDetailModal ref="jobNoticeModal" /> <!-- 채용공고 보기 -->
</template>

<style scoped>
</style>